<template>
  <v-card-text>
    Work in progress...
    <!-- <v-text-field
      v-model="query"
      readonly />

    <component
      v-for="(term, termIndex) in terms"
      :key="term.id"
      :is="term.type"
      :index="termIndex"
      :depth="term.type === 'Group' ? depth + 1 : depth"
      :field-options="fields"
      @add-term="addTerm"
      @delete-term="deleteTerm"
      @update-term="updateTerm" />

    <v-layout row>
      <v-flex>
        <v-btn
          @click.stop="addTerm(term.type)"
        >
          Add new term
        </v-btn>
      </v-flex>

      <v-flex>
        <v-btn
          @click.stop="addTerm(term.type)"
        >
          Add new group
        </v-btn>
      </v-flex>
    </v-layout> -->
  </v-card-text>
</template>

<script>
import SavedQueryRule from '@/components/SavedQueryRule'
import SavedQueryGroup from '@/components/SavedQueryGroup'

export default {
  name: 'SavedQueryCustom',

  components: {
    'Rule': SavedQueryRule,
    'Group': SavedQueryGroup
  },

  props: {
    fields: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      terms: [],
      depth: 0
    }
  },

  computed: {
    query: {
      get () {
        const queries = this.terms.map(term => {
          return term.query
        })
        return `${queries.join(' ')}`
      }
    }
  },

  methods: {
    addTerm (type) {
      this.terms.push({
        type,
        query: ''
      })
    },

    deleteTerm (index) {
      this.terms.splice(index, 1)
    },

    updateTerm (index, query) {
      this.terms[index].query = query
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SavedQueryCustom.vue